<template>
  <div id="reporter" style="margin-top: 10px">
    <div class="container-fluid">
      <div v-if="isSelectedBot">
        <ul class="nav nav-tabs">
          <li class="nav-item" :class="{ active: currentView == 'reporter-admin' }">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'reporter-admin'"
              >Admin</a
            >
          </li>
          <li class="nav-item" :class="{ active: currentView == 'reporter-user' }">
            <a class="nav-link" href="javascript:void(0);" @click="currentView = 'reporter-user'"
              >User</a
            >
          </li>
        </ul>
        <div class="container-fluid tab-container">
          <br />
          <keep-alive>
            <component :is="currentView"></component>
          </keep-alive>
        </div>
      </div>
      <div v-else>
        <template-empty></template-empty>
      </div>
    </div>
  </div>
</template>
 

<script>
import reporterAdmin from './reporter-admin'
import reporterUser from './reporter-user'
import templateEmpty from '@/components/view/template/template-empty'

export default {
  data: function () {
    return {
      currentView: 'reporter-admin'
    }
  },
  components: {
    'reporter-admin': reporterAdmin,
    'reporter-user': reporterUser,
    'template-empty': templateEmpty
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'reporter-admin':
        case 'reporter-user':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'reporter-admin'
          break
      }
    } else {
      vm.currentView = 'reporter-admin'
    }
  },
  computed: {
    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/oishineko/reporter.vue